module.exports = __webpack_public_path__ + "img/grifema-cassett-sdi-sicurezza-per-chiavi.02b623c8.png";